enum ProductIssueType {
    UseCurrentIssue = "USE_CURRENT_ISSUE",
    SelectAnIssue = "SELECT_AN_ISSUE"
}
export default ProductIssueType